export class DomiciliarioResponse {
    certificados:Domiciliario[];
    participantes:any;
    
}

export class Domiciliario{
    numeroControl:string = '';
    fechaIngreso:string = '';
    encargado:string = '';
    fechaVencimiento:string = '';
    observacion:string = '';
    
    
}